import Store from "../entity/store";
import Order from "../entity/order";

const validShipDate = (store: Store, order: Order): {
  result: boolean,
  msg?: string,
} => {
  let openTime: string | undefined = undefined;
  if (store.businessOpenTime) {
    store.businessOpenTime.set({
      seconds: 0,
      milliseconds: 0,
    });
    openTime = store.businessOpenTime.format('HH:mm');
  }
  let closeTime: string | undefined = undefined;
  if (store.businessCloseTime) {
    store.businessCloseTime.set({
      seconds: 0,
      milliseconds: 0,
    });
    closeTime = store.businessCloseTime.format('HH:mm');
  }
  const openTimes = openTime && openTime.split(':');
  const closeTimes = closeTime && closeTime.split(':');

  if (!order.shipDate) {
    console.warn('ship date is not null.');
    return {
      result: false,
      msg: 'お受け取り希望日時が指定されていません。',
    };
  }

  const shipDate = order.shipDate.clone();
  shipDate.set({ seconds: 0, milliseconds: 0 });

  if (store.minOrderDate().isAfter(shipDate)) {
    console.warn(store.minOrderDate());
    console.warn(shipDate);
    console.warn('ship date is less than min order date.');
    return {
      result: false,
      msg: 'お受け取り希望日時が最も早い時刻より前に設定されています。',
    };
  }

  const shipTimes = shipDate.format('HH:mm').split(':');
  const shipMinutes = parseInt(shipTimes[0]) * 60 + parseInt(shipTimes[1]);

  if (openTimes) {
    const openMinutes = parseInt(openTimes[0]) * 60 + parseInt(openTimes[1]);
    if (shipMinutes < openMinutes) {
      console.warn('ship time is less than open time.');
      return {
        result: false,
        msg: 'お受け取り希望日時が開店前に設定されています。',
      };
    }
  }

  if (closeTimes) {
    const closeMinutes = parseInt(closeTimes[0]) * 60 + parseInt(closeTimes[1]);
    if (shipMinutes > closeMinutes) {
      console.warn('ship time is greater than close time.');
      return {
        result: false,
        msg: 'お受け取り希望日時が閉店後に設定されています。',
      };
    }
  }

  return { result: true };
};

export default validShipDate;
